import { render, staticRenderFns } from "./PuzzleTemplateList.vue?vue&type=template&id=607c8033&"
import script from "./PuzzleTemplateList.vue?vue&type=script&lang=js&"
export * from "./PuzzleTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports